<template>
  <div class="mx-10 mt-10">
    <div class="pl-2 mb-5">
      <router-link
        :to="{ path: '/dashboard' }"
        style="text-decoration: none; color: #7986cb"
      >
        <v-icon color="#7986cb">mdi-arrow-left</v-icon
        ><span>Back to Portfolio Overview</span></router-link
      >
    </div>

    <v-container fluid class="mb-1">
      <v-row justify="center">
        <v-col sm="12" md="12" :lg="infoSizeLg" :xl="infoSizeXl">
          <v-card class="pl-5 pr-3">
            <v-row>
              <v-col sm="12" md="6" lg="6" xl="6">
                <BuildingInfoPanel
                  v-if="buildingData"
                  :buildingData="buildingData"
                />
              </v-col>
              <v-col sm="12" md="6" lg="6" xl="6"
                ><Map
                  v-if="showMap"
                  :latitude="latitude"
                  :longitude="longitude"
                />
                <div class="grayscale-img" v-if="!showMap">
                  <div style="text-align: center">
                    <h1 style="color: rgba(104, 104, 104, 1)">
                      No exact geolocation data available
                    </h1>
                  </div>
                </div>
              </v-col>
            </v-row>
          </v-card>
        </v-col>

        <v-col v-if="showScores" sm="12" md="12" lg="4" xl="3">
          <v-card>
            <SriScores
              :sriGrade="sriGrade"
              :sriScore="sriScore"
              :scoresEE="scoresEE"
              :scoresAO="scoresAO"
              :scoresASG="scoresASG"
            />
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-container fluid>
      <v-card class="mb-3">
        <v-card-title class="font-weight-light text-h5">
          Smart ready services overview <v-spacer></v-spacer>
          <v-row class="text-center">
            <v-spacer></v-spacer>
            <v-col sm="6" md="auto">
              <v-select
                outlined
                dense
                :items="catalogs"
                v-model="selectedCatalog"
                label="Domain service catalog"
                item-text="name"
                return-object
              >
              </v-select>
            </v-col>
            <v-col sm="6" md="auto">
              <v-dialog
                transition="msg-top-transition"
                max-width="1000"
                style="z-index: 1000"
                v-model="defaultWeightsDialog"
              >
                <template v-slot:default="msg">
                  <v-card class="pb-5">
                    <v-toolbar dense color="primary" dark
                      ><v-toolbar-title>Default weights</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="msg.value = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn></v-toolbar
                    >
                    <DefaultWeightsTable
                      class="pt-5 pb-2"
                      :weightsData="defaultWeights"
                    ></DefaultWeightsTable>
                  </v-card>
                </template>
              </v-dialog>
            </v-col>
            <v-col sm="6" md="auto">
              <v-dialog
                transition="msg-top-transition"
                max-width="1200"
                style="z-index: 1000"
                v-model="customWeightsDialog"
              >
                <template v-slot:default="slotProps">
                  <v-card>
                    <v-toolbar dense color="primary" dark
                      ><v-toolbar-title>Custom weights</v-toolbar-title>
                      <v-spacer></v-spacer>
                      <v-btn icon dark @click="slotProps.value = false">
                        <v-icon>mdi-close</v-icon>
                      </v-btn></v-toolbar
                    >
                    <v-card-text>
                      <CustomWeightsForm
                        @impactWeightsSumError="handleImpactWeightsSumError"
                        @domainWeightsSumError="handleDomainWeightsSumError"
                        @saveWeightsSuccess="handleSaveWeightsSuccess"
                        @weightsAlreadyExists="handleWeightsAlreadyExists"
                        :funitId="buildingId"
                        :weights="customWeights"
                      />
                    </v-card-text>
                  </v-card>
                </template>
              </v-dialog>
            </v-col>

            <v-col sm="6" md="auto">
              <v-menu>
                <template v-slot:activator="{ attrs, on }">
                  <v-btn color="primary" v-bind="attrs" v-on="on">
                    Actions <i class="material-icons">arrow_drop_down</i>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="(item, index) in detailedViewOptions"
                    :key="index"
                    :value="item.title"
                    @change="handleSelection(item.title)"
                    link
                    :disabled="item.disabled"
                  >
                    <v-list-item-title>{{ item.title }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </v-col>
            <v-col sm="6" md="auto">
              <v-dialog
                style="z-index: 1000"
                v-model="assessmentDialog"
                persistent
                max-width="600px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-show="editPermission"
                    ref="addBtn"
                    color="success"
                    dark
                    v-bind="attrs"
                    v-on="on"
                    @click="assessmentDialog = true"
                  >
                    Add new
                  </v-btn>
                </template>
                <v-card>
                  <v-toolbar color="primary" dense dark
                    >Domain assessment</v-toolbar
                  >
                  <v-card-title></v-card-title>
                  <v-card-text>
                    <DomainAssessmentForm
                      @submitForm="submitForm"
                      @closeDialog="assessmentDialog = false"
                    ></DomainAssessmentForm>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </v-col>
          </v-row>
        </v-card-title>
        <DomainAssessmentTable
          :data="domainAssessmentData"
        ></DomainAssessmentTable>
      </v-card>
      <v-card v-if="sriMatrixData">
        <v-card-title class="font-weight-light text-h5">
          Detailed scores by domain and impact criterion
        </v-card-title>
        <SriMatrix :sriMatrixData="sriMatrixData" />
      </v-card>
      <v-card class="my-3">
        <v-card-title class="font-weight-light text-h5">
          Monitoring assets <v-spacer></v-spacer>
        </v-card-title>

        <asset-table v-if="!loadingAssetData" :assets="assets" />
        <TableSkeletonLoader v-else :loading="loadingAssetData" />
      </v-card>
    </v-container>
    <v-dialog
      v-model="msgdialog"
      persistent
      max-width="600"
      style="z-index: 1000"
    >
      <v-card>
        <v-card-title class="text-h5"> {{ msgDialogHeader }} </v-card-title>
        <v-card-text v-html="msgdialogText"></v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="green darken-1" text @click="msgdialog = false">
            Ok
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      timeout="3000"
      v-model="snackbarVisible"
      absolute
      :color="snackbarType"
      top
    >
      <div class="text-center">
        <h4>{{ snackbarMessage }}.</h4>
      </div>
    </v-snackbar>
  </div>
</template>

<script>
import BuildingInfoPanel from "../components/BuildingInfoPanel.vue";
import DomainAssessmentForm from "../components/DomainAssessmentForm.vue";
import DomainAssessmentTable from "../components/DomainAssessmentTable";
import DefaultWeightsTable from "../components/DefaultWeightsTable.vue";
import SriScores from "../components/SriScores.vue";
import Map from "../components/Map.vue";
import EventBus from "../components/EventBus";
import SriMatrix from "../components/SriMatrix.vue";
import CustomWeightsForm from "../components/CustomWeightsForm.vue";

import services from "../rest/Services";
import utility from "../utility/utility";
import AssetTable from "../components/AssetTable.vue";
import TableSkeletonLoader from "../components/TableSkeletonLoader.vue";
//import router from "../router/index";

export default {
  name: "Building",

  components: {
    BuildingInfoPanel,
    DomainAssessmentForm,
    DomainAssessmentTable,
    DefaultWeightsTable,
    SriScores,
    Map,
    SriMatrix,
    CustomWeightsForm,
    AssetTable,
    TableSkeletonLoader,
  },
  props: {
    buildingId: {
      type: Number,
      default: null,
    },
  },

  data() {
    return {
      loadingAssetData: false,
      id: null,
      buildingData: null,
      infoPanelEnabled: false,
      domainTableEnabled: false,
      domainAssessmentData: [],
      defaultWeights: null,
      customWeights: null,
      sriGrade: "A",
      sriScore: 58,
      scoresEE: 0,
      scoresAO: 0,
      scoresASG: 0,
      assessmentDialog: false,
      customWeightsDialog: false,
      defaultWeightsDialog: false,
      msgdialog: false,
      showScores: true,
      infoSizeLg: 8,
      infoSizeXl: 9,
      latitude: 48.86901821476523,
      longitude: 2.330610858390532,
      sriMatrixData: null,
      breadcrumbs: [
        { text: "Dashboard", href: "/dashboard" },
        { text: "Building", href: "/category", disabled: true },
      ],
      showMap: true,
      domainCatalogServiceLookup: null,
      msgdialogText: "",
      msgDialogHeader: "",
      snackbarType: "success",
      snackbarVisible: false,
      snackbarMessage: "",
      editPermission: false,
      assets: [],
      catalogs: null,
      selectedCatalog: null,
      dbData: null,
      domains: null,
      domainServices: null,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((thisComponent) => {
      thisComponent.getAllData();
    });
  },
  mounted: function () {
    this.dbData = JSON.parse(sessionStorage.getItem("dbData"));
    this.setCodebookData();
    this.getDomainCatalogServiceLookup();
  },
  activated: function () {
    this.getPermission();
  },
  methods: {
    setCodebookData() {
      this.domains = Object.entries(
        this.dbData.enum_constants_lookup.domain
      ).map(([k, v]) => {
        return {
          id: parseInt(k) + 1,
          name: v,
        };
      });
      this.domainServices = Object.entries(
        this.dbData.service_description_lookup
      ).map(([k, v]) => {
        return {
          name: k,
          description: v,
        };
      });
    },
    handleSelection(value) {
      switch (value) {
        case "Calculate SRI":
          this.calculateSRI(true);
          break;
        case "Save SRI":
          this.saveSRI();
          break;
        case "Default weights":
          this.defaultWeightsDialog = true;
          break;
        case "Custom weights":
          this.customWeightsDialog = true;
          break;
      }
    },
    requiredServicesForDomainInCatalogLookup: function () {
      const requiredServices =
        this.domainCatalogServiceLookup
          .required_services_for_domain_in_catalog_lookup[
          this.selectedCatalog.name
        ];
      let allMissingServices = [];
      this.domains.forEach((domain) => {
        const services = this.domainAssessmentData.filter(
          (da) => da.domainId === domain.id
        );
        if (services.length === 0) return;

        const required = requiredServices[domain.name];
        let missingServices = required.filter((serviceName) => {
          return !services.some(
            (service) => service.domain_service === serviceName
          );
        });
        if (missingServices.length === 0) return;

        allMissingServices.push({
          domain: domain.name,
          services: missingServices.map((name) =>
            this.domainServices.find((service) => service.name === name)
          ),
        });
      });
      if (allMissingServices.length === 0) return false;
      this.setMsgDialog(
        "Missing services",
        this.createMessageForAllMissingServices(allMissingServices)
      );
      return true;
    },

    handleImpactWeightsSumError: function (sum) {
      this.setSnackbar(
        `The sum of impact weights in overall column is not exactly 1, it is ${sum}`,
        "error"
      );
    },
    handleDomainWeightsSumError: function (impact, sum) {
      this.setSnackbar(
        `The sum of domain weights for ${impact} impact is not exactly 1, it is ${sum}`,
        "error"
      );
    },
    handleSaveWeightsSuccess: function () {
      this.customWeightsDialog = false;
      this.setSnackbar(
        "Successfully saved all impact and domain weights",
        "success"
      );
    },
    handleWeightsAlreadyExists: function () {
      this.setSnackbar(
        `Same user defined weights are currently valid`,
        "error"
      );
    },
    setMsgDialog: function (header, text) {
      this.msgDialogHeader = header;
      this.msgdialogText = text;
      this.msgdialog = true;
    },
    setSnackbar: function (message, type) {
      this.snackbarMessage = message;
      this.snackbarType = type;
      this.snackbarVisible = true;
    },
    getPercentage: (score) => Math.round(score * 100),
    setSriScores: function (response) {
      if (!this.showScores) this.setScoresVisible(true);
      this.sriGrade = response.sri_grade;
      this.sriScore = this.getPercentage(response.sri_score);
      const scores = response.key_functionality_scores;
      this.scoresEE = this.getPercentage(scores.ENERGY_EFFICIENCY);
      this.scoresAO = this.getPercentage(scores.ADAPTABILITY_OCCUPANT);
      this.scoresASG = this.getPercentage(scores.ADAPTABILITY_SIGNAL_GRID);
    },
    saveSRI: function () {
      if (this.requiredServicesForDomainInCatalogLookup()) return;
      let body = {
        functional_unit_id: this.buildingId,
        catalog_id: this.selectedCatalog.id,
      };
      services
        .saveSriScores(body)
        .then((response) => {
          this.setSriScores(response.data);
          this.setSnackbar("Successfully saved sri scores", "success");

          //refresh building table
          EventBus.$emit("savedSriScore");
        })
        .catch((error) => {
          this.setMsgDialog(
            "Missing services",
            this.createMessageForMissingServices(error.response.data.message)
          );
        });
    },
    calculateSRI: function (withMessage) {
      if (this.requiredServicesForDomainInCatalogLookup()) return;
      let domainWeights, impactWeights, weightsType;
      if (this.customWeights.user_defined_domain_weights) {
        domainWeights = this.customWeights.user_defined_domain_weights;
        impactWeights = this.customWeights.user_defined_impact_weights;
        weightsType = "custom";
      } else {
        domainWeights = this.defaultWeights.default_domain_weights;
        impactWeights = this.defaultWeights.default_impact_weights;
        weightsType = "default";
      }
      //calculation with default weights
      let body = {
        catalog_id: this.selectedCatalog.id,
        domain_assessments: this.domainAssessmentData,
        domain_weights: domainWeights,
        impact_weights: impactWeights,
      };
      services
        .getSriScores(body)
        .then((response) => {
          this.setSriScores(response.data);
          if (withMessage) {
            this.setSnackbar(
              `Successfully calculated sri scores using ${weightsType} weights`,
              "success"
            );
          }

          this.sriMatrixData = response.data.impact_domain_scores;
        })
        .catch((error) => {
          this.setMsgDialog(
            "Missing services",
            this.createMessageForMissingServices(error.response.data.message)
          );
        });
    },
    createMessageForMissingServices(message) {
      const index = message.indexOf(":");
      const firstPart = message.slice(0, index + 1);
      const secondPart = message
        .slice(index + 1, message.length)
        .split(",")
        .join("<br>");
      return firstPart + "<br><br>" + secondPart;
    },
    createMessageForAllMissingServices(all) {
      let html = "";
      all.forEach((item) => {
        html += `<br><h4>${utility.convertStrToLabel(item.domain)}</h4> <br>`;
        html += "<ul>";
        item.services.forEach((service) => {
          html += `<li>${service.description}</li>`;
        });
        html += "</ul>";
      });
      return html;
    },

    submitForm: function (data) {
      data.functional_unit_id = this.buildingId;
      services
        .saveOrUpdateAssessment(data)
        .then(() => {
          this.setSnackbar(
            "Successfully saved or edited domain assessment",
            "success"
          );
          this.refreshAssessments();
        })
        .catch((error) => {
          if (error.response && error.response.status) {
            if (error.response.status === 409) {
              const presence = data.domain_presence.replace(/_/g, " ");
              const opposite = presence === "PRESENT" ? "ABSENT" : "PRESENT";
              this.setMsgDialog(
                "Domain presence mismatch",
                `Domain presence cannot be set to ${presence}
              if there is already an assessment service within specified domain,
               that has a domain presence value of ${opposite}`
              );
            }
          } else {
            console.error("An error occurred:", error);
          }
        });
    },
    setScoresVisible(isVisible) {
      this.showScores = isVisible;
      if (isVisible) {
        this.infoSizeLg = 8;
        this.infoSizeXl = 9;
      } else {
        this.infoSizeLg = 12;
        this.infoSizeXl = 12;
      }
    },

    getBuilding: function () {
      const params = {
        functional_unit_id: this.buildingId,
      };

      return services
        .getFunctionalUnitById(params)
        .then((response) => {
          const data = response.data;
          this.buildingData = data;
          if (data.functional_unit.centroid_lat) {
            this.showMap = true;
            this.latitude = data.functional_unit.centroid_lat;
            this.longitude = data.functional_unit.centroid_long;
          } else this.showMap = false;

          this.infoPanelEnabled = true;
          this.getDefaultWeights();
          if (data.score) {
            this.setScoresVisible(true);
          } else this.setScoresVisible(false);
          this.getCustomWeights();
        })
        .catch((error) => {
          if (error.response && error.response.status === 409) {
            console.log("error while fetching building");
          }
        });
    },
    getDomainCatalogServiceLookup() {
      services
        .getDomainCatalogServiceLookup()
        .then((response) => {
          this.domainCatalogServiceLookup = response.data;
          this.catalogs = Object.entries(
            this.domainCatalogServiceLookup.catalog_id_lookup
          ).map(([name, id]) => ({
            name,
            id,
          }));
          this.selectedCatalog = this.catalogs[0];
        })
        .catch((error) => console.log(error));
    },

    getDomainAssessments(params) {
      return services
        .getDomainAssessments(params)
        .then((response) => {
          this.domainAssessmentData = response.data.data;
          this.fillWithCodebookData();
        })
        .catch((error) => {
          console.log("error :>> ", error);
        });
    },
    fillWithCodebookData() {
      this.domainAssessmentData.forEach((da) => {
        da.description =
          this.dbData.service_description_lookup[da.domain_service];
        const domainName = this.dbData.service_domain_lookup[da.domain_service];
        da.domainId = this.domains.find(
          (domain) => domain.name === domainName
        ).id;
        da.domainName = utility.convertStrToLabel(domainName);
      });
    },
    getDefaultWeights() {
      let body = {
        building_type: "RESIDENTIAL",
        region: this.findRegionName(),
      };
      services
        .getWeights(body)
        .then((response) => {
          this.defaultWeights = response.data;
        })
        .catch((error) => {
          console.log("error :>> ", error.message);
        });
    },
    findRegionName() {
      const countryName =
        this.buildingData.functional_unit.address_data.country;
      return this.dbData.country_region_lookup[countryName];
    },
    getCustomWeights: function () {
      services
        .getWeights({ functional_unit_id: this.buildingId })
        .then((response) => {
          this.customWeights = response.data;
        })
        .catch((error) => {
          if (error.response) {
            console.log(error.response);
          } else if (error.request) {
            console.log(error.request);
          } else {
            console.log("Error", error.message);
          }
          console.log(error.config);
        });
    },
    refreshAssessments() {
      this.getDomainAssessments({ functional_unit_id: this.buildingId });
    },
    getAllData() {
      this.getBuilding().then(() => {
        this.getDomainAssessments({
          functional_unit_id: this.buildingId,
        }).then(() => {
          const assetIds = JSON.parse(localStorage.getItem("asset_ids"));
          if (assetIds) {
            this.getAssets();
          } else this.assets = [];
          if (this.buildingData.score_details) {
            this.setSriScores(this.buildingData.score_details);
            this.sriMatrixData =
              this.buildingData.score_details.impact_domain_scores;
          } else this.sriMatrixData = null;
        });
      });
    },
    getAssets() {
      this.loadingAssetData = true;
      services
        .getAssets()
        .then((response) => {
          this.loadingAssetData = false;
          const assetIds = JSON.parse(localStorage.getItem("asset_ids"));
          this.assets = response.data.assets
            .filter((asset) => assetIds.includes(asset.id))
            .map((asset) => {
              asset.file_type = "text/csv";
              asset.access_level = "Private";
              return asset;
            });
        })
        .catch((error) => {
          console.log("error while fetching assets", error.message);
          this.loadingAssetData = false;
        });
    },
    getPermission() {
      if (utility.checkIfAdmin()) {
        this.editPermission = true;
        return;
      }
      utility.getPermission(this.buildingId).then((permission) => {
        this.editPermission = permission;
      });
    },
  },

  computed: {
    buildingIdPresent: function () {
      return this.buildingId ? true : false;
    },
    calculateSriDisabled: function () {
      return this.domainAssessmentData.length === 0;
    },
    detailedViewOptions: function () {
      return [
        { title: "Calculate SRI", disabled: this.calculateSriDisabled },
        { title: "Save SRI", disabled: this.calculateSriDisabled },
        { title: "Default weights", disabled: false },
        { title: "Custom weights", disabled: false },
      ];
    },
  },
};
</script>

<style scoped>
.building-form {
  margin: auto;
  margin-top: 3em;
}
.grayscale-img {
  background-image: url("../assets/grayscale_map.png");
  height: 450px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.v-snack {
  top: 0;
  position: fixed;
  z-index: 9999;
}
</style>
